import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "leave-review-box" }
const _hoisted_2 = { class: "form-content" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "form-actions" }
const _hoisted_5 = { class: "stars-select" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 1,
  type: "button",
  class: "submit-button",
  disabled: ""
}

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Stars from '@/components/StarRating.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeaveReviewForm',
  props: {
    owner: { default: 'DIMFLIX' },
    repo: { default: 'dimflix.github.io' },
    category: { default: 'Reviews' }
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()

// --- New Review Submission ---
const draft = ref({ rating: 0, text: '' })
const canSubmit = computed(() => draft.value.rating > 0 && draft.value.text.trim().length > 0)
const newDiscussionUrl = computed(() => {
  const stars = '⭐'.repeat(draft.value.rating)
  const lines = [stars, '', draft.value.text.trim()]
  const body = encodeURIComponent(lines.join('\n'))
  const titleBase = t('reviews.titleForDiscussion') as string
  const title = encodeURIComponent(`${titleBase} (${draft.value.rating}/5)`)
  const categoryParam = props.category ? `category=${encodeURIComponent(props.category)}&` : ''
  return `https://github.com/${props.owner}/${props.repo}/discussions/new?${categoryParam}title=${title}&body=${body}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draft.value.text) = $event)),
        rows: "4",
        placeholder: _unref(t)('reviews.textPlaceholder')
      }, null, 8, _hoisted_3), [
        [_vModelText, draft.value.text]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", null, _toDisplayString(_unref(t)('reviews.yourRating')), 1),
          _createVNode(Stars, {
            value: draft.value.rating,
            interactive: "",
            size: 28,
            "onUpdate:value": _cache[1] || (_cache[1] = v => draft.value.rating = v)
          }, null, 8, ["value"])
        ]),
        (canSubmit.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: newDiscussionUrl.value,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "submit-button"
            }, _toDisplayString(_unref(t)('reviews.submit')), 9, _hoisted_6))
          : (_openBlock(), _createElementBlock("button", _hoisted_7, _toDisplayString(_unref(t)('reviews.submit')), 1))
      ])
    ])
  ]))
}
}

})